/* eslint-disable camelcase */
import { FC, useEffect, useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { platform } from 'network-utils';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { translate } from 'translations';
import { ChangePassword } from 'learning-panel-components';
import { selectUserUuid } from '@redux/slices/userSlice';
import { useGetAccountData, getAccountData } from '@queries/platform/accountSettings';

const ChangePasswordContainer: FC<ChangePasswordContainerProps> = (props: ChangePasswordContainerProps) => {
    const { onBack, onClose } = props;
    const services = platform.learningPanel.AccountSettingsAPIs;
    const [nickname, setNickname] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [errorMsg, setErrorMsg] = useState<string>();
    const [profilePicture, setProfilePicture] = useState<string>('');
    const userUuid = useSelector(selectUserUuid);
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const generalError = 'Something went wrong, please try again later';

    const { data } = useGetAccountData(userUuid);
    const accountData = data?.account_data;

    useEffect(() => {
        if (accountData) {
            setNickname(accountData.nickname);
            setEmail(accountData.email);
            setProfilePicture(
                accountData.profile_picture_url || `${process.env.PUBLIC_URL}/images/defaultProfilePicture.svg`
            );
        }
    }, [accountData]);

    const onChangePassword = (currentPassword: string, newPassword: string, confirmationPassword: string) => {
        mutate({
            current_password: currentPassword,
            password: newPassword,
            password_confirmation: confirmationPassword
        });
    };

    const submitChangePassword = async (input: {
        current_password: string;
        password: string;
        password_confirmation: string;
    }): Promise<{ success: boolean; error?: string }> => {
        const result = await services.updatePassword(input);
        return result;
    };

    const { mutate, isLoading } = useMutation(submitChangePassword, {
        onSuccess: (result: { success: boolean; error?: string }) => {
            if (result.success) {
                navigate('/app/login');
                return;
            }
            setErrorMsg(result.error);
        },
        onError: () => {
            setErrorMsg(generalError);
        }
    });

    const onCloseAccountSettings = () => {
        queryClient.removeQueries([getAccountData, userUuid]);
        onClose();
    };

    return (
        <ChangePassword
            nickname={nickname}
            email={email}
            onChangePassword={onChangePassword}
            onBack={onBack}
            isLoading={isLoading}
            errorResponseMessage={translate(errorMsg)}
            onClose={onCloseAccountSettings}
            imgSrc={profilePicture}
            hideForgotPassword
        />
    );
};
export interface ChangePasswordContainerProps {
    onBack: Function;
    setShowSuccessNotification?: Function;
    setNotificationMessage?: Function;
    onClose: Function;
}

export default ChangePasswordContainer;
